import { createRef } from "react";
import React from "react";
import Lottie from 'lottie-react-web'
import BackgroundAnimation from '../LottieAnimations/backgroundAnim2.json'
import ScrollIndicator from '../LottieAnimations/scroll.json'


export const LandingSection = () => {

    const useLayoutEffect = () => {
        if (isMobileTablet() === false) {
            window.addEventListener('scroll', onScroll);
            return () => window.removeEventListener('scroll', onScroll);
        }
    }

    const isMobileTablet = () => {
        var check = false;
        (function(a){
            if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) 
                check = true;
        })(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    const letters = [createRef(), createRef(), createRef(), createRef(), createRef(), createRef(), createRef(), createRef(), createRef(), createRef(), createRef(), createRef()]

    const onScroll = () => {

        const scrollPos = window.scrollY + window.innerHeight
        const progress = window.scrollY/window.innerHeight // Goes from 0 to 1

        if (progress > 0 && progress < 1.2) {
            const nToShow = Math.floor(progress/(1/13))
            for (let i = 0; i < 12; i++) { 
                if (i <= nToShow) {
                    letters[i].current.setState({showing: true});
                } else {
                    letters[i].current.setState({showing: false});
                }
            }
        } else if (progress < 1.2) {
            for (let i = 0; i < 12; i++) { 
                letters[i].current.setState({showing: false});
            }
        }

        if (scrollPos > 2*(window.innerHeight) && scrollPos < 3*window.innerHeight) {
            document.documentElement.style.setProperty('--landing-section-positioning', "relative");
            document.documentElement.style.setProperty('--filler-height-1', "100vh");
            document.documentElement.style.setProperty('--filler-height-2', "0vh");
            document.documentElement.style.setProperty('--welcome-opacity', "0");
        } else if (scrollPos < 3*window.innerHeight) {
            document.documentElement.style.setProperty('--landing-section-positioning', "fixed");
            document.documentElement.style.setProperty('--filler-height-1', "0vh");
            document.documentElement.style.setProperty('--filler-height-2', "200vh");
            document.documentElement.style.setProperty('--welcome-opacity', 1-3*progress);
        }
    }

    useLayoutEffect(() => {})
    
    return (
        <div id="start">
        <div class="LandingSectionFiller1"/>

        <h1 class="WelcomeText">WELCOME</h1>
        
        <div class="LandingSection">

            <div class="BackgroundAnimation">
                <Lottie options={{
                            animationData: BackgroundAnimation,
                            loop: true,
                        }}
                        direction={1}
                        speed={1}
                    />
            </div>
            
            <div class="NameContainer">
                <div class="WordContainer">
                    <AnimatedLetter ref={letters[0]} letter="M"/>
                    <AnimatedLetter ref={letters[1]} letter="A"/>
                    <AnimatedLetter ref={letters[2]} letter="R"/>
                    <AnimatedLetter ref={letters[3]} letter="I"/>
                    <AnimatedLetter ref={letters[4]} letter="U"/>
                    <AnimatedLetter ref={letters[5]} letter="S"/>
                </div>

                <div class="WordSpacer"/>

                <div class="WordContainer">
                    <AnimatedLetter ref={letters[6]} letter="G"/>
                    <AnimatedLetter ref={letters[7]} letter="E"/>
                    <AnimatedLetter ref={letters[8]} letter="N"/>
                    <AnimatedLetter ref={letters[9]} letter="T"/>
                    <AnimatedLetter ref={letters[10]} letter="O"/>
                    <AnimatedLetter ref={letters[11]} letter="N"/>
                </div>
            </div>
            
            <div class="ScrollIndicator">
                <Lottie 
                    options={{
                        animationData: ScrollIndicator,
                        loop: true,
                    }}
                    direction={1}
                    speed={1}
                />
            </div>
        </div>
        <div class="LandingSectionFiller2"/>
        </div>
    )
}

class AnimatedLetter extends React.Component {

    isMobileTablet() {
        var check = false;
        (function(a){
            if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) 
                check = true;
        })(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    constructor(props) {
        super(props);
        this.createRandomRotation = this.createRandomRotation.bind(this)
        this.state = {showing: false, hovering: false, animationData: null};
        this.letter = props.letter;
        if (this.isMobileTablet()  === true) {
            this.state = {showing: true};
        }
    }

    createRandomRotation() {
        const rotation = Math.floor((Math.random() * 720) - 360);
        document.documentElement.style.setProperty('--letter-rotation', rotation.toString()+"deg");
    }

    componentDidMount() {
        import(`../LetterAnimations/${this.letter}`).then(d => {
            this.setState({animationData: d})
        })
    }

    render() {
        if (!this.state.animationData) {
            return <h1 class="Letter" hidden={(this.state.showing || window.innerWidth < 1000) ? "false" : "true"}>{this.letter}</h1>
        }

        return (
            <div class="Letter"
                onMouseEnter={() => this.createRandomRotation()}>
                <Lottie 
                    options={{
                        animationData: this.state.animationData,
                        loop: false,
                    }}
                    direction={(this.state.showing || this.isMobileTablet() || window.innerWidth < 1000) ? 1 : -1}
                    speed={2.3}
                />
            </div>
        )
    }

}